<template lang="pug">
  section.navigation
    .logo-wrapper
      Logo(:brand="config.menu")
    .menu-ellipsis
      nav
        router-link(:to="link.url" v-for="(link, index) in config.navigation" :key="index") {{link.name}}

</template>

<script>
  import { mapState } from 'vuex'
  import Logo from '@/components/Logo'

  export default  {
    name: 'navigation',
    components: {
      Logo
    },
    computed: mapState([
      'config'
    ])
}
</script>

<style scoped lang="scss">
  .navigation{
    display: grid;
    grid-template-columns: 100px auto;
    align-items: center;
  }
  .menu-ellipsis{
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    display: table-cell;
    padding-left: 0.5rem;
    &:after{
      content: "";
      background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 15px;
    }
  }
  nav{
    display: inline;
    align-items: center;
    justify-content: center;
    a{
      color: #1b3043;
      font-size: 13.5px;
      line-height: 19.2857px;
      text-decoration: none;
      text-transform: uppercase;
      transition: all .3s ease;
      font-family: 'Open Sans', sans-serif;
      padding-left: 0.4rem;
      padding-right: 0.4rem;
      -webkit-font-smoothing: antialiased;
      &:hover{
        color: #b10925;
      }
    }
  }

  .logo-wrapper{
    max-width: 100px;
  }
</style>
